<template>
    <div class="crud-wrapper">
        <crud-toolbar :modalMode="modalMode" :newState="newState" :showBack="false" :title="modalTitle"
                      @onCommand="toolbarCommand"></crud-toolbar>

        <crud-form :modal-mode="modalMode" :ref="formName" v-model="validForm">

            <v-layout row wrap>
                <v-flex column xs12>
                    <label class="v-label v-label--active theme--light aLabel">Caixa</label>
                    <label class="title font-weight-bold grey--text">{{userName}}</label>
                </v-flex>

                <a-number-field label="Adicionar ao Caixa" number-mask="us" sm5 class="large-input" autofocus
                                v-model="formData.amount" validate="gtZero"></a-number-field>

            </v-layout>

        </crud-form>

    </div>
</template>

<script>
   import numeral from 'numeral';
   import CrudFormClass from "@consigmais-team/vue-common/layout/crudPage/crudFormClass";


   export default CrudFormClass.extend({

      name: 'AddCash',

      data() {
         return {
            title: 'Deposito',
            formName: 'addCashForm',

            formData: {
               id: null,
               companyId: this.$store.state.company.selectedStore,
               done_at: null,
               typeId: 12,
               amount: 0,
               notes: null
            }

         }
      },

      computed: {

         userName() {
            return this.$store.state.company.user.name;
         }

      },

      methods: {
         saveConfirmation() {
            return new Promise((resolve, reject) => {
               this.$msg.confirm({
                  title: 'Depositar no Caixa',
                  message: `Confirma entrada de ${this.formData.amount} ?`,
                  actions: ['Sim', 'Não'],
                  defaultAction: 0
               }).then((action) => (action === 0) ? resolve(true) : reject(false));
            });
         }
      }

   })

</script>

<style scoped>


</style>








// WEBPACK FOOTER //
// src/pages/AddCash.vue